import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_ergonomic_measures_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_ergonomic_measures_line_legal_requirements',
  name: 'Are ergonomic measures in line with legal requirements?',
  description:
    'Ergonomic measures seek to minimize risk factors resulting in musculoskeletal disorders, such as the avoidance of lifting heavy items, bending, reaching overhead, pushing and pulling heavy loads, and performing the same or similar tasks repetitively.',
  meta: {
    slcpMeta: {
      key: 'hs-33--2',
      number: 'HS-WOR-24',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-33--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29340,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
